import React from 'react'
import classNames from 'classnames'

export default function Badge(props) {
    const {
        children,
        className,
        style,
    } = props

    return (
        <p
            className={classNames(
                'position-absolute',
                'bg-info',
                'text-black',
                'text-center',
                'shadow',
                'mb-0',
                className
            )}
            style={{
                fontSize: 14,
                fontWeight: 800,
                paddingBlock: 2,
                paddingInline: 12,
                ...style,                
            }}
        >
            {children}
        </p>
    )
}
